import React from "react";
import MobileImage from "../../atoms/MobileImage";
import styled from "styled-components";
import AppLinks from "../../atoms/AppLinks";

const Quote = () => {
  return (
    <Wrapper>
      <div className="mobile-image">
        <MobileImage />
      </div>
      <div className="cotiza-btns">
        <a href="#" className="btn btn-warning">
          Cotiza tu seguro
        </a>
        <AppLinks />
      </div>
      <div className="container">
        <h6>Trabajamos con más de 30 aseguradoras</h6>
      </div>
    </Wrapper>
  );
};

// Quote Insurance (quote-insurance)
const Wrapper = styled.section`
  padding: 25px 0;
  margin-top: -120px;
  background: #fff;

  .mobile-image {
    margin: -28rem 0 -6rem;
    @media (min-width: 768px) {
      display: none;
    }
  }

  .cotiza-btns {
    width: 95vw;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    @media (min-width: 992px) {
      flex-direction: row;
    }
  }
  .btn {
    padding: 8px 40px;
    margin-right: 80px;
    margin-bottom: 23px;
    font-size: 18px;
    @media only screen and (min-width: 992px) {
      margin-bottom: 0;
    }
  }

  .quote-insurance-img {
    width: 130x;
    height: 45px;
    padding: 5px;
    border-radius: 5px;
    margin-left: 40px;
    @media only screen and (min-width: 1400px) {
      width: 207x;
      height: 71px;
    }
  }

  h6 {
    color: #5268c2;
    margin-top: 1.6rem;
    font-size: 18px;
    font-weight: bold;
    text-align: cetner;
    display: none;
    @media only screen and (min-width: 768px) {
      display: block;
    }
  }

  @media only screen and (max-width: 1200px) {
    margin-top: 0;
  }
  @media (max-width: 767px) {
    .btn {
      margin-right: 30px;
    }
  }
  @media (max-width: 576px) {
    .btn {
      margin: 0 30px 20px;
    }
  }
`;
export default Quote;
